var Marionette = require('backbone.marionette');

var Person = require('../../models/person-model');
var Organization = require('../../models/organization');

var CommonUtils = require('../../utils/common-utils.js');
var Dicts = require('../../data/dicts');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var RepresentativeFormView = Marionette.View.extend({
    template: require('../../templates/contacts/representative-form.html'),

    ui: {
        cancel: '#cancel-representative',
        save: '#save-representative',

        type: '#type',
        npi: '#npi',
        name: '#name',
        relation: '#relation',
        comment: '#comment',

        personToContactType: '#person-to-contact-type',
        personToContactPrefix: '#contact-person-prefix',
        personToContactFirstName: '#contact-person-first-name',
        personToContactLastName: '#contact-person-last-name'
    },

    regions: {
        entitySelect: '#entity-select'
    },

    events: {
        'click @ui.save': 'saveRepresentation',
        'click @ui.cancel': 'cancelRepresentation',

        'change @ui.type': 'typeChanged',
        'keyup @ui.npi': 'npiChanged',
        'keyup @ui.name': 'nameChanged',
        'keyup @ui.relation': 'relationChanged',
        'keyup @ui.comment': 'commentChanged',

        'keyup @ui.personToContactType': 'personToContactTypeChanged',
        'keyup @ui.personToContactPrefix': 'personToContactPrefixChanged',
        'keyup @ui.personToContactFirstName': 'personToContactFirstNameChanged',
        'keyup @ui.personToContactLastName': 'personToContactLastNameChanged'
    },

    childViewEvents: {
        'suggestor:selected:person-entity': 'onEntitySelected',
        'suggestor:selected:organization-entity': 'onEntitySelected'
    },

    templateContext: function () {
        return {
            title: this.mode == 'add' ? 'New representative' : "Edit representative",
            mode: this.mode == 'add' ? 'Add' : "Edit",
            representative: this.representative,
            contactPersonPrefix: (this.representative.personToContact || {}).prefix,
            contactPersonFirstName: (this.representative.personToContact || {}).firstName,
            contactPersonLastName: (this.representative.personToContact || {}).lastName,
        };
    },

    initialize: function (options) {
        //_.bindAll(this, 'saveAddress', 'zipChanged', 'addressChanged', 'townChanged', 'stateChanged', 'onRender', 'usageChanged', 'cancel');
        this.utils = new CommonUtils();
        if (options) {
            this.representative = options.representative || {uuid: this.utils.generatedUUID(), groupUuid: this.utils.generatedUUID(), personToContact:{}};
            if (!this.representative.personToContact){
                this.representative.personToContact = {};
            }
            this.mode = options.mode;
        }
    },

    onRender: function () {
        this.ui.type.selectize({
            allowEmptyOption: false
        });

        if (this.representative.type == "PERSON") {
            this.renderPersonSelect();
        } else if (this.representative.type == "ORGANIZATION") {
            this.renderOrganizationSelect();
        }
    },

    typeChanged: function (event) {
        this.representative.type = event.target.value;
        if (this.representative.type == "PERSON") {
            this.renderPersonSelect();
        } else if (this.representative.type == "ORGANIZATION") {
            this.renderOrganizationSelect();
        }
    },

    npiChanged: function (event) {
        this.representative.npi = event.target.value;
    },

    nameChanged: function (event) {
        this.representative.name = event.target.value;
    },

    relationChanged: function (event) {
        this.representative.relation = event.target.value;
    },

    commentChanged: function(event) {
        this.representative.comment = event.target.value;
    },

    personToContactTypeChanged: function(event){
        this.representative.personToContactType = event.target.value;
    },
    personToContactPrefixChanged: function(event){
        this.representative.personToContact.prefix = event.target.value;
    },
    personToContactFirstNameChanged: function(event){
        this.representative.personToContact.firstName = event.target.value;
    },
    personToContactLastNameChanged: function(event){
        this.representative.personToContact.lastName = event.target.value;
    },

    renderPersonSelect: function () {
        var that = this;
        if (_.isEmpty(that.representative.entityId)) {
            that.renderPersonSuggestor();
        } else {
            $.when(
                $.ajax({
                    type: "GET",
                    url: '/api/dbo/preview?id=' + that.representative.entityId + '&type=person'
                })
            ).done(function (resp) {
                if (resp.length > 0) {
                    that.renderPersonSuggestor(resp[0]);
                } else {
                    that.renderPersonSuggestor();
                }
            }).fail(function (jqXHR, textStatus) {
                that.renderPersonSuggestor();
            });
        }
    },

    renderOrganizationSelect: function() {
        var that = this;
        if (_.isEmpty(that.representative.entityId)) {
            that.renderOrganizationSuggestor();
        } else {
            $.when(
                $.ajax({
                    type: "GET",
                    url: '/api/dbo/preview?id=' + that.representative.entityId + '&type=organization'
                })
            ).done(function (resp) {
                if (resp.length > 0) {
                    that.renderOrganizationSuggestor(resp[0]);
                } else {
                    that.renderOrganizationSuggestor();
                }
            }).fail(function (jqXHR, textStatus) {
                that.renderOrganizationSuggestor();
            });
        }
    },

    renderPersonSuggestor: function(defaultSelected) {
        var that = this;
        this.detachChildView('entitySelect');

        that.showChildView('entitySelect', new RemoteSuggesterView({
            tag: 'person-entity',
            inputId: 'entity-id',
            maxNumberOfElements: 20,
            url: '/api/dbo/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=person',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Person",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return arr[index] || null;
            },
            defaultSelected: defaultSelected
        }));
    },

    renderOrganizationSuggestor: function(defaultSelected) {
        var that = this;
        this.detachChildView('entitySelect');

        that.showChildView('entitySelect', new RemoteSuggesterView({
            tag: 'organization-entity',
            inputId: 'entity-id',
            maxNumberOfElements: 20,
            url: '/api/dbo/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=organization',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Organization",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return arr[index] || null;
            },
            defaultSelected: defaultSelected
        }));
    },

    cancelRepresentation: function () {
        this.triggerMethod('on:representative:action', {mode: 'cancel'});
    },

    saveRepresentation: function () {
        this.triggerMethod('on:representative:saved', {mode: this.mode, representative: this.representative});
    },

    onEntitySelected: function(selected) {
        if (selected == null) return;
        this.representative.entityId = selected.id;
        this.representative.npi = selected.object.npi;
        this.ui.npi.val(selected.object.npi || '');
        this.representative.name = selected.name;
        this.ui.name.val(selected.name);
    }

});

module.exports = RepresentativeFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/contacts/representative-form.js
// module id = 264
// module chunks = 0